import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { apiRequest } from "../api/apiClient";

export default function MultiqcReportBlob() {
    const { id } = useParams();
    const token = process.env.REACT_APP_ATLAS_TOKEN;

    const [url, setUrl] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        let cancelled = false;
        let objectUrl;

        const load = async () => {
            if (!id || !token) return;

            setLoading(true);

            try {
                const params = new URLSearchParams({
                    study_id: id,
                    token,
                });

                const endpoint = `quality.php?${params.toString()}`;

                const response = await apiRequest(endpoint, {
                    method: "GET",
                    responseType: "text", // 👈 importante si tu apiRequest lo soporta
                });

                const blob = new Blob([response.content[0]], { type: "text/html" });
                objectUrl = URL.createObjectURL(blob);

                if (!cancelled) {
                    setUrl(objectUrl);
                }

            } catch (e) {
                if (!cancelled) console.error(e);
            } finally {
                if (!cancelled) setLoading(false);
            }
        };

        load();

        return () => {
            cancelled = true;
            if (objectUrl) URL.revokeObjectURL(objectUrl);
        };

    }, [id, token]);

    if (loading) return <div>Cargando…</div>;
    if (!url) return null;

    return (
        <iframe
            title="MultiQC"
            src={url}
            style={{
                width: "100%",
                height: "100vh",
                border: "none",
            }}
            sandbox="allow-same-origin allow-scripts allow-downloads allow-forms"
        />
    );
}
